<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <div class="search-bar">
          <el-input
            v-model="searchParams.title"
            placeholder="请输入商品名称"
            clearable
            style="width: 220px; margin-right: 10px"
          ></el-input>

          <!-- 新增：商品类型 goods_type -->
          <el-select
            v-model.number="searchParams.goods_type"
            placeholder="请选择商品类型"
            style="width: 180px; margin-right: 10px"
            clearable
          >
            <el-option
              v-for="item in goodsTypeList"
              :key="item.type"
              :label="item.desc"
              :value="item.type"
            />
          </el-select>

          <el-select
            v-model.number="searchParams.type"
            placeholder="请选择商品分类"
            style="width: 180px; margin-right: 10px"
            @change="handleTypeChange"
          >
            <el-option
              v-for="item in goodsLevelList"
              :key="item.type"
              :label="item.desc"
              :value="item.type"
            />
          </el-select>

          <el-select
            v-model.number="searchParams.level_id"
            placeholder="请选择商品等级"
            style="width: 180px; margin-right: 10px"
          >
            <el-option
              v-for="item in currentLevelItems"
              :key="item.level_id"
              :label="item.name"
              :value="item.level_id"
            />
          </el-select>

          <el-button type="primary" icon="el-icon-search" @click="getMenuList"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
          <el-button type="success" icon="el-icon-plus" @click="handlePcAddGoods"
            >添加商品</el-button
          >
        </div>

        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
          @row-click="handlePcRowClick"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="商品名称" prop="title" min-width="200" />
          <el-table-column label="商品图片" width="120" align="center">
            <template slot-scope="scope">
              <img
                :src="scope.row.image"
                style="width: 60px; height: 60px; object-fit: cover"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="价格"
            prop="price"
            width="100"
            align="center"
          />
          <!-- 新增表格列：商品类型 goods_type -->
          <el-table-column label="商品类型" width="120" align="center">
            <template slot-scope="scope">
              {{ getGoodsTypeName(scope.row.goods_type) }}
            </template>
          </el-table-column>
          <el-table-column
            label="分类"
            prop="type_name"
            width="100"
            align="center"
          />
          <el-table-column
            label="等级"
            prop="level_name"
            width="100"
            align="center"
          />

          <el-table-column label="商品状态" width="180" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-text="上架"
                inactive-text="下架"
                :active-value="1"
                :inactive-value="0"
                @click.native.stop
                @change="handleGoodsStatus(scope.row)"
              />
            </template>
          </el-table-column>

          <el-table-column label="创建时间" prop="created_at" width="180" />
          <el-table-column label="更新时间" prop="updated_at" width="180" />
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click.stop="handlePcEdit(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC 商品详情弹窗 -->
        <el-dialog
          title="商品详情"
          :visible.sync="pcShowCard"
          width="500px"
          center
          close-on-click-modal
          append-to-body
        >
          <div class="goods-card" v-if="pcCurrentGoods">
            <div class="goods-img">
              <img :src="pcCurrentGoods.image" alt="商品图片" />
            </div>
            <div class="goods-info">
              <p>
                <label>商品ID：</label><span>{{ pcCurrentGoods.id }}</span>
              </p>
              <p>
                <label>商品名称：</label><span>{{ pcCurrentGoods.title }}</span>
              </p>
              <p>
                <label>商品类型：</label><span>{{ pcTypeText }}</span>
              </p>
              <p>
                <label>等级ID：</label
                ><span>{{ pcCurrentGoods.level_id || "未设置" }}</span>
              </p>
              <p>
                <label>价格：</label
                ><span>{{ pcCurrentGoods.price || "0" }}</span>
              </p>
              <p>
                <label>商品描述：</label
                ><span>{{ pcCurrentGoods.content || "暂无描述" }}</span>
              </p>
            </div>
          </div>
        </el-dialog>

        <!-- PC 添加/编辑弹窗 -->
        <el-dialog
          :title="pcDialogType == 'add' ? '添加商品' : '编辑商品'"
          :visible.sync="pcDialogVisible"
          width="550px"
          @close="pcResetForm"
          append-to-body
        >
          <el-form
            :model="pcForm"
            :rules="addRules"
            ref="pcFormRef"
            label-width="100px"
          >
            <el-form-item label="商品名称" prop="title">
              <el-input
                v-model="pcForm.title"
                placeholder="请输入商品名称"
                style="width: 300px"
              />
            </el-form-item>

            <!-- 新增：添加/编辑时选择 goods_type -->
            <el-form-item label="商品类型" prop="goods_type">
              <el-select
                v-model.number="pcForm.goods_type"
                placeholder="请选择商品类型"
                style="width: 300px"
              >
                <el-option
                  v-for="item in goodsTypeList"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="商品分类" prop="type">
              <el-select
                v-model.number="pcForm.type"
                placeholder="请选择分类"
                style="width: 300px"
                @change="handlePcFormTypeChange"
              >
                <el-option
                  v-for="item in goodsLevelList"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="商品等级" prop="level_id">
              <el-select
                v-model.number="pcForm.level_id"
                placeholder="请选择等级"
                style="width: 300px"
              >
                <el-option
                  v-for="item in pcFormLevelItems"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="价格" prop="price">
              <el-input
                v-model="pcForm.price"
                placeholder="请输入价格"
                style="width: 300px"
              />
            </el-form-item>

            <el-form-item label="商品图片" prop="image">
              <div style="display: flex; align-items: center; gap: 12px">
                <el-button
                  type="primary"
                  icon="el-icon-picture"
                  @click="pcOpenImageDialog"
                  >选择图片</el-button
                >
                <div
                  v-if="pcForm.image"
                  style="
                    border: 1px solid #eee;
                    padding: 4px;
                    border-radius: 4px;
                  "
                >
                  <img
                    :src="pcForm.image"
                    style="
                      width: 52px;
                      height: 52px;
                      object-fit: cover;
                      display: block;
                    "
                  />
                </div>
              </div>
            </el-form-item>

            <el-form-item label="商品描述" prop="content">
              <el-input
                v-model="pcForm.content"
                type="textarea"
                rows="4"
                placeholder="请输入商品描述（选填）"
                style="width: 300px"
              />
            </el-form-item>
          </el-form>

          <div slot="footer">
            <el-button @click="pcDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="pcSubmitForm">确认提交</el-button>
          </div>
        </el-dialog>

        <!-- PC 图片选择弹窗 -->
        <el-dialog
          title="选择图片"
          :visible.sync="pcImageDialogVisible"
          width="850px"
          append-to-body
        >
          <div
            v-loading="imageLoading"
            element-loading-text="图片加载中..."
            style="padding: 10px"
          >
            <div
              style="
                display: flex;
                gap: 10px;
                margin-bottom: 15px;
                align-items: center;
              "
            >
              <el-select
                v-model.number="pcImageSearch.type"
                placeholder="图片类型"
                style="width: 180px"
                clearable
              >
                <el-option
                  v-for="item in image_type"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="getImageList"
                >筛选</el-button
              >
              <el-button icon="el-icon-refresh" @click="resetImageSearch"
                >重置</el-button
              >
            </div>

            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 12px;
                max-height: 420px;
                overflow-y: auto;
                padding: 5px;
              "
            >
              <div
                v-for="img in imageList"
                :key="img.id"
                @click="pcSelectImage(img)"
                style="
                  cursor: pointer;
                  padding: 4px;
                  border-radius: 6px;
                  text-align: center;
                "
                :style="{
                  border:
                    pcSelectedImageUrl == img.url
                      ? '2px solid #1989fa'
                      : '2px solid transparent',
                  background:
                    pcSelectedImageUrl == img.url ? '#f0f7ff' : 'transparent',
                }"
              >
                <img
                  :src="img.url"
                  style="
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    border-radius: 4px;
                    display: block;
                  "
                />
                <span
                  style="
                    font-size: 12px;
                    margin-top: 4px;
                    color: #666;
                    display: block;
                  "
                >
                  {{ getImageTypeName(img.type) }}
                </span>
              </div>
            </div>

            <el-pagination
              @size-change="handleImageSizeChange"
              @current-change="handleImageCurrentChange"
              :current-page="pcImageSearch.page"
              :page-size="pcImageSearch.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="imageTotal"
              style="margin-top: 15px; text-align: right"
            ></el-pagination>
          </div>

          <div slot="footer">
            <el-button @click="pcImageDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="pcConfirmSelectImage"
              >确认选择</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <!-- 搜索栏 -->
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.title"
            placeholder="商品名称"
            clearable
            size="medium"
            prefix-icon="el-icon-search"
          />

          <!-- 移动端新增 goods_type 筛选 -->
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-select
              v-model.number="searchParams.goods_type"
              placeholder="商品类型"
              clearable
              size="medium"
              style="flex: 1"
            >
              <el-option
                v-for="item in goodsTypeList"
                :key="item.type"
                :label="item.desc"
                :value="item.type"
              />
            </el-select>

            <el-select
              v-model.number="searchParams.type"
              placeholder="商品分类"
              clearable
              size="medium"
              style="flex: 1"
              @change="handleTypeChange"
            >
              <el-option
                v-for="item in goodsLevelList"
                :key="item.type"
                :label="item.desc"
                :value="item.type"
              />
            </el-select>
          </div>

          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-select
              v-model.number="searchParams.level_id"
              placeholder="商品等级"
              clearable
              size="medium"
              style="flex: 1"
            >
              <el-option
                v-for="item in currentLevelItems"
                :key="item.level_id"
                :label="item.name"
                :value="item.level_id"
              />
            </el-select>
          </div>

          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getMenuList"
              style="flex: 1"
              >搜索</el-button
            >
            <el-button plain round @click="resetSearch" style="flex: 1"
              >重置</el-button
            >
            <el-button
              type="success"
              plain
              round
              @click="handleMobileAddGoods"
              style="flex: 1"
              >添加</el-button
            >
          </div>
        </div>

        <!-- 卡片列表 -->
        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="handleMobileRowClick(item)"
          >
            <div class="card-header">
              <img :src="item.image" class="avatar" />
              <div class="info">
                <div class="title">{{ item.title }}</div>
                <div class="meta">
                  ID:{{ item.id }} | {{ getGoodsTypeName(item.goods_type) }} | {{ item.type_name }}
                </div>
              </div>
              <div class="status" :class="item.status == 1 ? 'on' : 'off'">
                {{ item.status == 1 ? "上架" : "下架" }}
              </div>
            </div>
            <div class="card-body">
              <div>价格：¥{{ item.price }}</div>
              <div>创建：{{ item.created_at }}</div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="handleMobileEdit(item)"
                >编辑</el-button
              >
              <el-switch
                v-model="item.status"
                size="mini"
                active-text="上架"
                inactive-text="下架"
                :active-value="1"
                :inactive-value="0"
                @click.native.stop
                @change="handleGoodsStatus(item)"
              />
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageInfo.total"
            pager-count="2"
            small
          />
        </div>

        <!-- 移动端详情弹窗 -->
        <el-dialog
          title="商品详情"
          :visible.sync="mobileShowCard"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div v-if="mobileCurrentGoods" style="padding: 10px 0">
            <div style="text-align: center; margin-bottom: 15px">
              <img
                :src="mobileCurrentGoods.image"
                style="
                  width: 120px;
                  height: 120px;
                  object-fit: cover;
                  border-radius: 8px;
                "
              />
            </div>
            <el-descriptions :column="1" border size="small">
              <el-descriptions-item label="商品ID">{{
                mobileCurrentGoods.id
              }}</el-descriptions-item>
              <el-descriptions-item label="商品名称">{{
                mobileCurrentGoods.title
              }}</el-descriptions-item>
              <el-descriptions-item label="商品类型">{{
                getGoodsTypeName(mobileCurrentGoods.goods_type)
              }}</el-descriptions-item>
              <el-descriptions-item label="分类">{{
                mobileTypeText
              }}</el-descriptions-item>
              <el-descriptions-item label="等级">{{
                mobileCurrentGoods.level_name || "未设置"
              }}</el-descriptions-item>
              <el-descriptions-item label="价格"
                >¥{{ mobileCurrentGoods.price }}</el-descriptions-item
              >
              <el-descriptions-item label="状态">
                <span
                  :style="
                    mobileCurrentGoods.status == 1 ? 'color:#00C48C' : 'color:#F56C6C'
                  "
                >
                  {{ mobileCurrentGoods.status == 1 ? "上架" : "下架" }}
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="描述">{{
                mobileCurrentGoods.content || "暂无描述"
              }}</el-descriptions-item>
            </el-descriptions>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button @click="mobileShowCard = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- 移动端添加/编辑弹窗 -->
        <el-dialog
          :title="mobileDialogType == 'add' ? '添加商品' : '编辑商品'"
          :visible.sync="mobileDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileForm"
            :rules="addRules"
            ref="mobileFormRef"
            label-width="85px"
            size="small"
          >
            <el-form-item label="商品名称" prop="title">
              <el-input v-model="mobileForm.title" placeholder="名称" size="medium" />
            </el-form-item>

            <!-- 移动端新增 goods_type 选择 -->
            <el-form-item label="商品类型" prop="goods_type">
              <el-select
                v-model.number="mobileForm.goods_type"
                placeholder="商品类型"
                size="medium"
              >
                <el-option
                  v-for="item in goodsTypeList"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="商品分类" prop="type">
              <el-select
                v-model.number="mobileForm.type"
                placeholder="分类"
                size="medium"
                @change="handleMobileFormTypeChange"
              >
                <el-option
                  v-for="item in goodsLevelList"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="商品等级" prop="level_id">
              <el-select
                v-model.number="mobileForm.level_id"
                placeholder="等级"
                size="medium"
              >
                <el-option
                  v-for="item in mobileFormLevelItems"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input v-model="mobileForm.price" placeholder="价格" size="medium" />
            </el-form-item>
            <el-form-item label="商品图片">
              <div style="display: flex; align-items: center; gap: 10px">
                <el-button type="primary" size="mini" @click="mobileOpenImageDialog"
                  >选择图片</el-button
                >
                <div
                  v-if="mobileForm.image"
                  style="
                    border: 1px solid #eee;
                    padding: 2px;
                    border-radius: 4px;
                  "
                >
                  <img
                    :src="mobileForm.image"
                    style="width: 46px; height: 46px; object-fit: cover"
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="商品描述">
              <el-input
                v-model="mobileForm.content"
                type="textarea"
                rows="3"
                placeholder="描述"
                size="medium"
              />
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            style="
              text-align: right;
              display: flex;
              justify-content: flex-end;
              gap: 10px;
            "
          >
            <el-button size="medium" @click="mobileDialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="mobileSubmitForm"
              >保存</el-button
          >
          </div>
        </el-dialog>

        <!-- 移动端图片选择弹窗 -->
        <el-dialog
          title="选择图片"
          :visible.sync="mobileImageDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div
            v-loading="imageLoading"
            element-loading-text="加载中..."
            style="padding: 5px"
          >
            <div style="display: flex; gap: 8px; margin-bottom: 10px">
              <el-select
                v-model.number="mobileImageSearch.type"
                placeholder="类型"
                size="mini"
                clearable
                style="flex: 1"
              >
                <el-option
                  v-for="item in image_type"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-button size="mini" type="primary" @click="getImageList"
                >筛选</el-button
              >
              <el-button size="mini" @click="resetImageSearch">重置</el-button>
            </div>

            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                max-height: 45vh;
                overflow-y: auto;
                padding: 5px;
              "
            >
              <div
                v-for="img in imageList"
                :key="img.id"
                @click="mobileSelectImage(img)"
                style="
                  padding: 3px;
                  border-radius: 6px;
                  cursor: pointer;
                  text-align: center;
                "
                :style="{
                  border:
                    mobileSelectedImageUrl == img.url
                      ? '2px solid #1989fa'
                      : '2px solid transparent',
                  background:
                    mobileSelectedImageUrl == img.url ? '#f0f7ff' : 'transparent',
                }"
              >
                <img
                  :src="img.url"
                  style="
                    width: 70px;
                    height: 70px;
                    object-fit: cover;
                    border-radius: 4px;
                    display: block;
                  "
                />
                <span
                  style="
                    font-size: 12px;
                    color: #666;
                    margin-top: 3px;
                    display: block;
                  "
                >
                  {{ getImageTypeName(img.type) }}
                </span>
              </div>
            </div>

            <div style="margin-top: 10px; text-align: center">
              <el-pagination
                @size-change="handleImageSizeChange"
                @current-change="handleImageCurrentChange"
                :current-page="mobileImageSearch.page"
                :page-size="mobileImageSearch.page_size"
                layout="prev, pager, next"
                :total="imageTotal"
              />
            </div>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button size="mini" @click="mobileImageDialogVisible = false"
              >取消</el-button
            >
            <el-button size="mini" type="primary" @click="mobileConfirmSelectImage"
              >确认</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "GoodsTable",
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },
      searchParams: {
        page: 1,
        page_size: 10,
        title: "",
        goods_type: "", // 新增
        type: "",
        level_id: "",
      },
      goodsTypeList: [], // 商品类型下拉数据
      goodsLevelList: [],
      currentLevelItems: [],
      typeMap: {
        1: "无限",
        2: "擂台",
        3: "许愿",
        4: "闯关",
        5: "福利屋",
        6: "幸运屋",
        7: "进阶",
      },
      addRules: {
        title: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
        goods_type: [ // 新增校验
          { required: true, message: "请选择商品类型", trigger: "change" },
        ],
        type: [
          { required: true, message: "请选择商品分类", trigger: "change" },
        ],
        level_id: [
          { required: true, message: "请选择商品等级", trigger: "change" },
        ],
        price: [{ required: true, message: "请输入价格", trigger: "blur" }],
        image: [
          { required: true, message: "请选择商品图片", trigger: "change" },
        ],
        content: [],
      },

      // ==================== PC 独立数据 ====================
      pcShowCard: false,
      pcCurrentGoods: null,
      pcDialogVisible: false,
      pcDialogType: "add",
      pcFormLevelItems: [],
      pcForm: {
        goods_id: "",
        title: "",
        goods_type: "", // 新增
        type: "",
        level_id: "",
        price: "",
        image: "",
        content: "",
      },
      pcImageDialogVisible: false,
      pcImageSearch: { page: 1, page_size: 12, type: "" },
      pcSelectedImageUrl: "",

      // ==================== 移动端独立数据 ====================
      mobileShowCard: false,
      mobileCurrentGoods: null,
      mobileDialogVisible: false,
      mobileDialogType: "add",
      mobileFormLevelItems: [],
      mobileForm: {
        goods_id: "",
        title: "",
        goods_type: "", // 新增
        type: "",
        level_id: "",
        price: "",
        image: "",
        content: "",
      },
      mobileImageDialogVisible: false,
      mobileImageSearch: { page: 1, page_size: 12, type: "" },
      mobileSelectedImageUrl: "",

      // 图片公共数据
      imageLoading: false,
      imageList: [],
      imageTotal: 0,
      image_type: [],
    };
  },
  computed: {
    pcTypeText() {
      if (!this.pcCurrentGoods) return "";
      return this.typeMap[this.pcCurrentGoods.type] || "未知分类";
    },
    mobileTypeText() {
      if (!this.mobileCurrentGoods) return "";
      return this.typeMap[this.mobileCurrentGoods.type] || "未知分类";
    },
  },
  created() {
    this.getMenuList();
  },
  methods: {
    // 公共列表接口
    getMenuList() {
      this.loading = true;
      api.goods
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data;
            this.goodsLevelList = res.data.data.goods_level;
            this.goodsTypeList = res.data.data.goods_type || []; // 获取商品类型下拉
            this.pageInfo.total = res.data.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 获取商品类型名称
    getGoodsTypeName(type) {
      const item = this.goodsTypeList.find(t => t.type == type);
      return item ? item.desc : "未知类型";
    },

    // ==================== PC 方法 ====================
    handlePcRowClick(row) {
      this.pcCurrentGoods = row;
      this.pcShowCard = true;
    },
    handlePcAddGoods() {
      this.pcDialogType = "add";
      this.pcResetForm();
      this.pcDialogVisible = true;
    },
    handlePcEdit(row) {
      this.pcDialogType = "edit";
      this.pcForm = {
        goods_id: row.id,
        title: row.title,
        goods_type: Number(row.goods_type), // 新增
        type: Number(row.type),
        level_id: Number(row.level_id),
        price: row.price,
        image: row.image,
        content: row.content || "",
      };
      this.handlePcFormTypeChange(this.pcForm.type);
      this.pcDialogVisible = true;
    },
    handlePcFormTypeChange(type) {
      const find = this.goodsLevelList.find((item) => item.type == type);
      this.pcFormLevelItems = find ? find.goods_level : [];
    },
    pcSubmitForm() {
      this.$refs.pcFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const apiFn = this.pcDialogType === "add" ? api.goods.add : api.goods.edit;
        apiFn(this.pcForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.pcDialogVisible = false;
              this.getMenuList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    pcResetForm() {
      this.pcForm = {
        goods_id: "",
        title: "",
        goods_type: "", // 新增
        type: "",
        level_id: "",
        price: "",
        image: "",
        content: "",
      };
      this.pcFormLevelItems = [];
      this.$nextTick(() => {
        if (this.$refs.pcFormRef) this.$refs.pcFormRef.clearValidate();
      });
    },
    pcOpenImageDialog() {
      this.pcImageDialogVisible = true;
      this.pcSelectedImageUrl = "";
      this.getImageList();
    },
    pcSelectImage(img) {
      this.pcSelectedImageUrl = img.url;
    },
    pcConfirmSelectImage() {
      if (!this.pcSelectedImageUrl) {
        this.$message.warning("请先选择一张图片");
        return;
      }
      this.pcForm.image = this.pcSelectedImageUrl;
      this.pcImageDialogVisible = false;
    },

    // ==================== 移动端方法 ====================
    handleMobileRowClick(row) {
      this.mobileCurrentGoods = row;
      this.mobileShowCard = true;
    },
    handleMobileAddGoods() {
      this.mobileDialogType = "add";
      this.mobileResetForm();
      this.mobileDialogVisible = true;
    },
    handleMobileEdit(row) {
      this.mobileDialogType = "edit";
      this.mobileForm = {
        goods_id: row.id,
        title: row.title,
        goods_type: Number(row.goods_type), // 新增
        type: Number(row.type),
        level_id: Number(row.level_id),
        price: row.price,
        image: row.image,
        content: row.content || "",
      };
      this.handleMobileFormTypeChange(this.mobileForm.type);
      this.mobileDialogVisible = true;
    },
    handleMobileFormTypeChange(type) {
      const find = this.goodsLevelList.find((item) => item.type == type);
      this.mobileFormLevelItems = find ? find.goods_level : [];
    },
    mobileSubmitForm() {
      this.$refs.mobileFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const apiFn = this.mobileDialogType === "add" ? api.goods.add : api.goods.edit;
        apiFn(this.mobileForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.mobileDialogVisible = false;
              this.getMenuList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    mobileResetForm() {
      this.mobileForm = {
        goods_id: "",
        title: "",
        goods_type: "", // 新增
        type: "",
        level_id: "",
        price: "",
        image: "",
        content: "",
      };
      this.mobileFormLevelItems = [];
      this.$nextTick(() => {
        if (this.$refs.mobileFormRef) this.$refs.mobileFormRef.clearValidate();
      });
    },
    mobileOpenImageDialog() {
      this.mobileImageDialogVisible = true;
      this.mobileSelectedImageUrl = "";
      this.getImageList();
    },
    mobileSelectImage(img) {
      this.mobileSelectedImageUrl = img.url;
    },
    mobileConfirmSelectImage() {
      if (!this.mobileSelectedImageUrl) {
        this.$message.warning("请先选择一张图片");
        return;
      }
      this.mobileForm.image = this.mobileSelectedImageUrl;
      this.mobileImageDialogVisible = false;
    },

    // ==================== 公共方法 ====================
    handleTypeChange(type) {
      this.searchParams.level_id = "";
      let findItem = this.goodsLevelList.find((item) => item.type == type);
      this.currentLevelItems = findItem ? findItem.goods_level : [];
    },
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        title: "",
        goods_type: "", // 新增
        type: "",
        level_id: "",
      };
      this.currentLevelItems = [];
      this.getMenuList();
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getMenuList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getMenuList();
    },
    getImageList() {
      this.imageLoading = true;
      api.images
        .index({ params: this.pcImageSearch })
        .then((res) => {
          if (res.data.code == 1000) {
            this.imageList = res.data.data.data || [];
            this.imageTotal = res.data.data.total || 0;
            this.image_type = res.data.data.image_type || [];
          }
        })
        .finally(() => {
          this.imageLoading = false;
        });
    },
    resetImageSearch() {
      this.pcImageSearch = { page: 1, page_size: 12, type: "" };
      this.mobileImageSearch = { page: 1, page_size: 12, type: "" };
      this.getImageList();
    },
    handleImageSizeChange(val) {
      this.pcImageSearch.page_size = val;
      this.mobileImageSearch.page_size = val;
      this.getImageList();
    },
    handleImageCurrentChange(val) {
      this.pcImageSearch.page = val;
      this.mobileImageSearch.page = val;
      this.getImageList();
    },
    getImageTypeName(type) {
      const item = this.image_type.find((t) => t.type == type);
      return item ? item.desc : "未知分类";
    },
    handleGoodsStatus(row) {
      const old = row.status;
      this.loading = true;
      api.goods
        .status({
          goods_id: String(row.id),
          status: String(row.status),
        })
        .catch(() => {
          row.status = old;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
/* ====================== PC 原有样式 ====================== */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.goods-card {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 10px;
}
.goods-img img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
}
.goods-info {
  flex: 1;
  font-size: 14px;
}
.goods-info p {
  margin: 10px 0;
  line-height: 1.6;
}
.goods-info label {
  font-weight: bold;
  width: 80px;
  display: inline-block;
}

/* ====================== 移动端样式 ====================== */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  object-fit: cover;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.status {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}
.status.on {
  background: #e6f7ee;
  color: #00c48c;
}
.status.off {
  background: #fef0f0;
  color: #f56c6c;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/goods/index.vue